import {Request} from '@simpli/serialized-request'
import {AuthResponse} from '@/model/response/AuthResponse'

export class AuthRequest {
  static async signIn(code: string, state: string) {
    const res = await Request.post(
      `/client/auth`,
      {},
      {
        baseURL: process.env.VUE_APP_API_URL,
        withCredentials: true,
        params: {code, state},
      }
    )
      .name('signIn')
      .delay(1000)
      .as(AuthResponse)
      .getResponse()

    return res?.data ?? res
  }

  static async me() {
    return await Request.get('/client/auth', {
      baseURL: process.env.VUE_APP_API_URL,
      withCredentials: true,
    })
      .name('verifySignIn')
      .as(AuthResponse)
      .getData()
  }
}
